import React from 'react';
import LocationTemplate from './LocationTemplate';

const AuroraPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Aurora"
      stateName="North Carolina"
      countyName="Beaufort"
      zipCodes={["27806"]}
      latitude={35.3034}
      longitude={-76.7891}
      population={515}
      historicalFact="Named after the Roman goddess of dawn; home to Aurora Fossil Museum featuring ancient marine fossils."
      nearbyTowns={[
        "Washington, NC",
        "Chocowinity, NC",
        "Belhaven, NC",
        "Bath, NC",
        "Edward, NC",
        "Blounts Creek, NC",
        "Pinetown, NC",
        "New Bern, NC"
      ]}
    />
  );
};

export default AuroraPage;